import bookingEngine from './bookingEngine/model';

export default {
    bookingEngine,
};
